<div class="flex flex-col h-full w-full">
  @if (!isManageMode()) {
    <etxe-photo-gallery
      [photos]="photos()"
      [propertyCharacteristics]="propertyCharacteristics()"
      (addClicked)="openUploadModal()"
      (manageClicked)="toggleManageMode()"
    ></etxe-photo-gallery>
  }

  @if (isManageMode()) {
    <etxe-photo-manage
      [photos]="photos()"
      [propertyCharacteristics]="propertyCharacteristics()"
      (photosUpdated)="updatePhotos($event)"
      (addClicked)="openUploadModal()"
      (doneClicked)="toggleManageMode()"
    ></etxe-photo-manage>
  }
</div>
